// Rilevamento automatico dei 14 allergeni UE dalle parole di piatti/ingredienti (IT)
export const ALLERGENS = [
  { id: 1, name: "Glutine", kw: ["glutine", "frumento", "grano", "farina", "pane", "pasta", "pangrattato", "couscous", "orzo", "farro", "segale", "seitan", "biscott", "pizza", "focaccia", "gnocchi", "tortell", "lasagn", "cracker", "brioche", "crostini", "bruschett"] },
  { id: 2, name: "Crostacei", kw: ["gamber", "scampi", "aragost", "astice", "granchio", "crostace", "mazzancoll"] },
  { id: 3, name: "Uova", kw: ["uovo", "uova", "maionese", "frittata", "meringa", "zabaione", "carbonara", "all'uovo"] },
  { id: 4, name: "Pesce", kw: ["pesce", "branzino", "orata", "tonno", "salmone", "merluzzo", "acciug", "alici", "sgombro", "spigola", "baccal", "nasello", "sogliola", "triglia", "colatura", "ricciola", "pesce spada"] },
  { id: 5, name: "Arachidi", kw: ["arachid", "noccioline"] },
  { id: 6, name: "Soia", kw: ["soia", "tofu", "edamame"] },
  { id: 7, name: "Latte", kw: ["latte", "burro", "formagg", "parmigian", "panna", "mozzarella", "yogurt", "ricotta", "mascarpone", "besciamella", "gorgonzola", "pecorino", "grana", "stracchino", "fontina", "caciocavallo", "gelato"] },
  { id: 8, name: "Frutta a guscio", kw: ["nocciol", "mandorl", "noci", "noce", "pistacchi", "anacardi", "pinoli", "pecan", "macadamia"] },
  { id: 9, name: "Sedano", kw: ["sedano"] },
  { id: 10, name: "Senape", kw: ["senape", "mostarda"] },
  { id: 11, name: "Sesamo", kw: ["sesamo", "tahin"] },
  { id: 12, name: "Solfiti", kw: ["solfiti", "vino", "aceto", "uvetta", "frutta secca"] },
  { id: 13, name: "Lupini", kw: ["lupini"] },
  { id: 14, name: "Molluschi", kw: ["cozze", "vongole", "calamar", "seppia", "polpo", "totano", "ostric", "molluschi", "moscardin", "canestrell", "capasant", "tartufi di mare"] },
];

export function detectAllergens(text) {
  const t = (text || "").toLowerCase();
  return ALLERGENS.filter((a) => a.kw.some((k) => t.includes(k)));
}

export function aggregateAllergens(dishes) {
  const map = new Map();
  (dishes || []).forEach((d) => detectAllergens(d).forEach((a) => map.set(a.id, a)));
  return Array.from(map.values()).sort((x, y) => x.id - y.id);
}
